import { Fragment } from "react";
import AvailableMeals from "./AvailableMeals";
import MealsSummary from "./MealsSummary";
import MealTitle from "./MealTitle";


const Meals = () =>{
    return <Fragment>
        <MealsSummary/>
        <MealTitle>MAIN MEALS</MealTitle>
        <MealTitle>Biryani</MealTitle>
        <AvailableMeals/>
        <MealTitle>Tandoori</MealTitle>
        <AvailableMeals/>
        <MealTitle>Sundries</MealTitle>
        <AvailableMeals/>
    </Fragment>

}

export default Meals